import type { TabInfo } from './types';

type TabProps = TabInfo;

export const Tab = ({ children }: TabProps) => <>{children}</>;
